const state = {
  vinIdentificationData: {
    vin: null,
    year: null,
    month: null
  },
  mileage: null,
  hsnTsnData: {
    hsn: null,
    tsn: null,
    year: null,
    month: null,
    model: null,
    equipment: null,
    vehicle: null
  },
  prevRoutes: [],
  engageCustomer: null,
  engageVehicle: null
};

export default state;
